<template>
    <div>
        <section class="pt-8 pb-11 pt-md-9 pb-md-12 py-lg-14 bg-light bg">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-10 text-center" data-aos="fade-up">

                        <h1 class="display-3 font-weight-bold text-white">
                            Agri-marketplace for spot & forward sales powered by blockchain
                        </h1>

                        <p class="font-size-lg text-white-75 mb-6 mb-md-8">
                            AcreCX offers a digital marketplace backed by smart contracts enabling farmers and buyers to buy and sell commodities at future dates while eliminating transaction
                            risks.
                        </p>

                        <a href="/docs/AcreCX_June2019.pdf" target="_blank" class="btn btn-success mr-1 lift">
                            Download Brochure <i class="fe fe-download ml-3"></i>
                        </a>
                        <a href="#!" class="btn btn-success-soft lift">
                            Learn more
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <!-- Shape -->
        <div class="position-relative">
            <div class="shape shape-bottom shape-fluid-x svg-shim text-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"/>
                </svg>
            </div>
        </div>

        <!-- Features  -->
        <section class="pt-8 pt-md-10" id="about">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-center">
                        <a href="#about" class="btn btn-white btn-rounded-circle shadow mt-n12 mt-md-n14" data-toggle="smooth-scroll">
                            <i class="fe fe-arrow-down"></i>
                        </a>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8 text-center">
                        <h2 class="font-weight-bold">
                            Designed for <span class="text-success">marketplaces</span> and <span class="text-success">farm co-ops</span>
                        </h2>
                        <p class="font-size-lg text-muted mb-9">
                            Solutions designed for large farming cooperatives of tens of thousands of farmers to small farms, very small farms, and micro farming communities.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="row align-items-center mb-10" data-aos="fade-up">
                            <div class="col-4 col-lg-5">
                                <img src="../../assets/img/illustrations/illustration-4_a.png" alt="..." class="img-fluid">
                            </div>
                            <div class="col-8 col-lg-7">
                                <h3 class="font-weight-bold mb-2">
                                    Contract Book
                                </h3>
                                <p class="text-gray-700 mb-0">
                                    Manage contracts efficiently for your agri business. Create, sign digitally,
                                    agree on payment terms securely all in one place and save valuable time.
                                </p>
                            </div>
                        </div>
                        <div class="row align-items-center mb-10" data-aos="fade-up">
                            <div class="col-4 col-lg-5">
                                <img src="../../assets/img/illustrations/illustration-8_a.png" alt="..." class="img-fluid">
                            </div>
                            <div class="col-8 col-lg-7">
                                <h3 class="font-weight-bold mb-2">
                                    Unified Billing & Invoicing
                                </h3>
                                <p class="text-gray-700 mb-0">
                                    Organize all invoices, bills, receipts in one place and feel at peace.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="row align-items-center mb-10" data-aos="fade-up">
                            <div class="col-4 col-lg-5">
                                <img src="../../assets/img/illustrations/illustration-7_a.png" alt="..." class="img-fluid">
                            </div>
                            <div class="col-8 col-lg-7">
                                <h3 class="font-weight-bold mb-2">
                                    Price Discovery
                                </h3>
                                <p class="text-gray-700 mb-0">
                                    How much are your commodities worth? Keep track of what's happening in commodity
                                    markets and be better informed about the prices of your commodities.
                                </p>
                            </div>
                        </div>
                        <div class="row align-items-center mb-10" data-aos="fade-up">
                            <div class="col-4 col-lg-5">
                                <img src="../../assets/img/illustrations/illustration-6_a.png" alt="..." class="img-fluid">
                            </div>
                            <div class="col-8 col-lg-7">
                                <h3 class="font-weight-bold mb-2">
                                    Warehouse Management
                                </h3>
                                <p class="text-gray-700 mb-0">
                                    Control warehouse operations including inventory, shipping, sorting, and storing.
                                    Keep track of inventory levels in real-time, reduce order fulfillment times with improved transparency!
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>

        <!-- Stats -->
        <section class="pt-8 pt-md-11">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="card-group card-border card-border-lg border-success shadow-light-lg">
                            <div class="card border-left-md">
                                <div class="card-body">
                                    <h2 class="font-weight-bold text-center mb-0">
                                        <count-to :start-val="0"
                                                  :end-val="marketplaces"
                                                  :duration='5000'
                                                  :decimals="0"
                                                  :prefix="'+'"></count-to>
                                    </h2>
                                    <p class="text-center text-muted mb-0">
                                        Marketplaces
                                    </p>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <h2 class="font-weight-bold text-center mb-0">
                                        <count-to :start-val="0"
                                                  :end-val="txVolume"
                                                  :duration='4000'
                                                  :decimals="0"
                                                  :prefix="'+'"
                                                  :suffix="'k tonnes'"></count-to>
                                    </h2>
                                    <p class="text-center text-muted mb-0">
                                        Trade Volume
                                    </p>
                                </div>
                            </div>
                            <div class="card border-left-md">
                                <div class="card-body">
                                    <h2 class="font-weight-bold text-center mb-0">
                                        <count-to :start-val="0"
                                                  :end-val="txValue"
                                                  :duration='3000'
                                                  :decimals="0"
                                                  :prefix="'+'"
                                                  :suffix="'M USD'"></count-to>
                                    </h2>
                                    <p class="text-center text-muted mb-0">
                                        Transaction Value
                                    </p>
                                </div>
                            </div>
                            <div class="card border-left-md">
                                <div class="card-body">
                                    <h2 class="font-weight-bold text-center mb-0">
                                        <count-to :start-val="0"
                                                  :end-val="shg"
                                                  :duration='6000'
                                                  :decimals="0"
                                                  :prefix="'+'"></count-to>
                                    </h2>
                                    <p class="text-center text-muted mb-0">
                                        Self Help Groups (SHGs)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Dashboard  -->
        <section class="pt-8 pt-md-11">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8 text-center" data-aos="fade-right">
                        <h6 class="text-uppercase text-success text-uppercase font-weight-bold">
                            Features
                        </h6>
                        <h1 class="font-weight-bold">
                            For farmers and commodities buyers
                        </h1>
                        <p class="font-size-lg text-muted mb-7">
                            Keep track of what's happening with your commodities, and manage your contracts with farmers and buyers from anywhere in the world
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 order-md-2" data-aos="zoom-in-up">
                        <div class="device-combo device-combo-macbook-iphonex mb-6 mb-md-0">
                            <div class="device device-macbook">
                                <img src="../../assets/img/Acrcx_dashbord_1.jpg" class="device-screen" alt="...">
                                <img src="../../assets/img/devices/macbook.svg" class="img-fluid" alt="...">
                            </div>
                            <div class="device device-iphonex">
                                <img src="../../assets/img/Acrcx_mobile.jpg" class="device-screen" alt="...">
                                <img src="../../assets/img/devices/iphonex.svg" class="img-fluid" alt="...">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Partners -->
        <section class="pt-8 pt-md-11">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8 text-center" data-aos="fade-left">
                        <h6 class="text-uppercase text-success text-uppercase font-weight-bold">
                            Partners
                        </h6>
                        <h1 class="font-weight-bold">
                            Partners sharing a common goal
                        </h1>
                        <p class="font-size-lg text-muted mb-7">
                            We have partnered with companies from around the world and with a variety of backgrounds sharing a common goal of building sustainable institutions
                        </p>
                    </div>
                </div>

                <div class="row" data-aos="fade-right">
                    <div class="col-4 col-md-3 text-center align-middle">
                        <div class="img-fluid img-fluid mb-6 mb-md-8 svg-shim">
                            <a href="https://surechain.org/" target="_blank">
                                <img src="../../assets/img/partners/surechain.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-4 col-md-3 text-center align-middle">
                        <div class="img-fluid img-fluid mb-6 mb-md-8 svg-shim">
                            <a href="https://www.aacari.org/" target="_blank">
                                <img src="../../assets/img/partners/aacari.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-4 col-md-3 text-center align-middle">
                        <div class="img-fluid img-fluid mb-6 mb-md-8 svg-shim">
                            <a href="https://www.coyopartners.com/" target="_blank">
                                <img src="../../assets/img/partners/coyo.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-4 col-md-3 text-center align-middle">
                        <div class="img-fluid img-fluid mb-6 mb-md-8 svg-shim">
                            <a href="https://www.investinafrica.com/" target="_blank">
                                <img src="../../assets/img/partners/iia.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-4 col-md-3 text-center align-middle">
                        <div class="img-fluid img-fluid mb-6 mb-md-8 svg-shim">
                            <a href="https://www.truvito.io" target="_blank">
                                <img src="../../assets/img/partners/truvito.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-4 col-md-3 text-center align-middle">
                        <div class="img-fluid img-fluid mb-6 mb-md-8 svg-shim">
                            <a href="https://www.borlaug.network" target="_blank">
                                <img src="../../assets/img/partners/borlaug.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-4 col-md-3 text-center align-middle">
                        <div class="img-fluid img-fluid mb-6 mb-md-8 svg-shim">
                            <a href="https://worldstartupfactory.com/" target="_blank">
                                <img src="../../assets/img/partners/wsf.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-4 col-md-3 text-center align-middle">
                        <div class="img-fluid img-fluid mb-6 mb-md-8 svg-shim">
                            <a href="https://foodstars.net/startups/" target="_blank">
                                <img src="../../assets/img/partners/foodstars.png">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import countTo from 'vue-count-to';

    export default {
        name: "Landing",
        components: {
            countTo
        },
        data() {
            return {
                marketplaces: 30000,
                txVolume: 10,
                txValue: 7,
                shg: 210000
            };
        },
        mounted() {
        },
        methods: {
            onReady(countUp) {
                window.addEventListener('scroll', evt => {
                    evt.pageY > countUp.target.getBoundingClientRect().top ? countUp.start() : null;
                });
            }
        }
    }
</script>

<style scoped>
    .bg {
        background-image: url('../../assets/img/bg/farmer.jpg');
        box-shadow: inset 0 0 0 100vmax rgba(54, 64, 78, 0.75);
    }
</style>